import React, {useState} from "react";
import {useEffect} from "react";
import {useParams} from "react-router";
import {useForm} from "react-hook-form";
import {useHistory} from "react-router-dom";

const UpdateService = () => {
  let history = useHistory();
  const {register, handleSubmit} = useForm();

  const [service, setService] = useState({});
  const {id} = useParams();

  useEffect(() => {
    const url = `https://hidden-everglades-07947.herokuapp.com/services/${id}`;
    fetch(url)
      .then(res => res.json())
      .then(data => setService(data));
  }, []);

  const handleNameChange = e => {
    const updatedName = e.target.value;
    const updatedService = {
      name: updatedName,
      description: service.description,
      price: service.price,
      img: service.img
    };
    setService(updatedService);
  };
  const handleDescriptionChange = e => {
    const updatedDescription = e.target.value;
    const updatedService = {
      name: service.name,
      description: updatedDescription,
      price: service.price,
      img: service.img
    };
    setService(updatedService);
  };
  const handlePriceChange = e => {
    const updatedPrice = e.target.value;
    const updatedService = {
      name: service.name,
      description: service.description,
      price: updatedPrice,
      img: service.img
    };
    setService(updatedService);
  };
  const handleImgChange = e => {
    const updatedImg = e.target.value;
    const updatedService = {
      name: service.name,
      description: service.description,
      price: service.price,
      img: updatedImg
    };
    setService(updatedService);
  };
  const handleUpdateService = e => {
    const url = `https://hidden-everglades-07947.herokuapp.com/services/${id}`;
    fetch(url, {
      method: "PUT",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify(service)
    })
      .then(res => res.json())
      .then(data => {
        if (data.modifiedCount > 0) {
          alert("Update Successful");
          setService({});
          history.push("/home#services");
        }
      });
    // e.preventDefault();
  };
  return (
    <div>
      <form onSubmit={handleSubmit(handleUpdateService)}>
        <input
          {...register("name")}
          placeholder="name"
          onChange={handleNameChange}
          value={service.name || ""}
        />
        <br />
        <br />
        <textarea
          {...register("description")}
          placeholder="description"
          onChange={handleDescriptionChange}
          value={service.description || ""}
        />
        <br />
        <br />
        <input
          type="number"
          {...register("price")}
          placeholder="price"
          onChange={handlePriceChange}
          value={service.price || ""}
        />
        <br />
        <br />
        <input
          {...register("img")}
          placeholder="image url"
          onChange={handleImgChange}
          value={service.img || ""}
        />
        <br />
        <br />

        <input type="submit" value="Update" />
      </form>
    </div>
  );
};

export default UpdateService;
